import { DollarSign, Hash, Activity, Building2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const formatNumber = (num) => {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toLocaleString();
};

const formatCost = (cost) => {
  return `$${Number(cost).toFixed(2)}`;
};

const KpiCards = ({ summary }) => {
  const totalCost = summary.reduce((sum, r) => sum + Number(r.total_cost), 0);
  const totalTokens = summary.reduce((sum, r) => sum + r.total_tokens, 0);
  const totalRequests = summary.reduce((sum, r) => sum + r.request_count, 0);
  const activeCompanies = new Set(summary.map((r) => r.company_uid)).size;

  const items = [
    { label: 'Total Cost', value: formatCost(totalCost), icon: DollarSign },
    { label: 'Total Tokens', value: formatNumber(totalTokens), icon: Hash },
    { label: 'Total Requests', value: formatNumber(totalRequests), icon: Activity },
    { label: 'Active Companies', value: activeCompanies.toString(), icon: Building2 }
  ];

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      {items.map((item) => (
        <Card key={item.label}>
          <CardContent className="p-4">
            <div className="flex items-center justify-between pb-2">
              <div className="tracking-tight text-sm font-medium text-muted-foreground">{item.label}</div>
              <item.icon className="h-4 w-4 text-muted-foreground" />
            </div>
            <div className="text-2xl font-bold">{item.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default KpiCards;
